// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IWZ_g","productName":"Table_productName__1H5vA"};